'use client';

import a__default from "react";
import { Text } from "../../atoms/Text/Text.js";
import { Check } from "../../../react-icons.js";
import { classNames } from "../../utils/styles/classNames.js";
import { selected, highlighted, optionCursor, option, optionContent, optionLabel } from "./Select.css.js";
function Option({
  option: option$1,
  isHighlighted,
  isSelected,
  itemProps
}) {
  return /* @__PURE__ */ a__default.createElement(
    "li",
    {
      className: classNames(
        option,
        optionCursor.default,
        isHighlighted && highlighted,
        !isHighlighted && isSelected && selected
      ),
      key: option$1.value,
      ...itemProps
    },
    /* @__PURE__ */ a__default.createElement("div", { className: optionContent }, /* @__PURE__ */ a__default.createElement(
      Text,
      {
        "aria-hidden": option$1.a11yDescription ? "true" : void 0,
        className: optionLabel,
        color: "onLight.text.primary",
        style: option$1.dangerousFontFamily ? { fontFamily: option$1.dangerousFontFamily } : void 0,
        variant: "body.base"
      },
      option$1.label
    ), option$1.caption && /* @__PURE__ */ a__default.createElement(
      Text,
      {
        "aria-hidden": option$1.a11yDescription ? "true" : void 0,
        color: "onLight.text.tertiary",
        variant: "body.xs"
      },
      option$1.caption
    ), option$1.a11yDescription && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, option$1.a11yDescription)),
    isSelected && /* @__PURE__ */ a__default.createElement(Check, { color: "action.positive.darkest", size: "sm" })
  );
}
export {
  Option
};
